import React, { useState, useRef, useEffect } from "react";
import { DotsVerticalIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";

export default function ImageCard({ img, onDownload, onDelete, onViewFullScreen }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleEdit = () => {
        setMenuOpen(false);
        navigate("/generate", {
            state: {
                prompt: img.prompt || "",
                seed: img.seed ?? -1,
                width: img.width ?? 768,
                height: img.height ?? 768,
            },
        });
    };

    return (
        <div className="relative bg-black/30 backdrop-blur-md rounded-lg overflow-hidden shadow-lg group">
            {/* Thumbnail */}
            <img
                src={img.imageUrl}
                alt={img.prompt}
                className="w-full h-48 object-cover cursor-pointer"
                onClick={() => onViewFullScreen(img)} // 📢 KEY POINT: click image to open fullscreen
            />

            {/* Ellipsis Button */}
            <button
                type="button"
                onClick={() => setMenuOpen((o) => !o)}
                className="absolute top-2 right-2 p-1 bg-black/50 rounded-full hover:bg-black/70 transition"
                aria-label="Open menu"
            >
                <DotsVerticalIcon className="h-5 w-5 text-white" />
            </button>

            {/* Dropdown Menu */}
            {menuOpen && (
                <div
                    ref={menuRef}
                    className="absolute top-10 right-2 w-40 bg-black/80 rounded-md shadow-lg z-20 overflow-hidden"
                >
                    <button
                        type="button"
                        onClick={() => {
                            setMenuOpen(false);
                            onDownload(img);
                        }}
                        className="block w-full px-4 py-2 text-left text-white hover:bg-gray-700"
                    >
                        Download
                    </button>
                    <button
                        type="button"
                        onClick={handleEdit}
                        className="block w-full px-4 py-2 text-left text-white hover:bg-gray-700"
                    >
                        Edit
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            setMenuOpen(false);
                            onDelete(img);
                        }}
                        className="block w-full px-4 py-2 text-left text-red-400 hover:bg-gray-700"
                    >
                        Delete
                    </button>
                </div>
            )}

            {/* Caption */}
            <div className="p-4 pt-2">
                <p className="text-gray-300 text-sm truncate">{img.prompt}</p>
            </div>
        </div>
    );
}
